import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, NavLink, Link, useLocation } from "react-router-dom";
import { Nav, NavLink as ReactstrapNavLink } from "reactstrap";
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { NewPolicyButtonForPolicyCreateEdit } from "../../common/buttons";
import UserAccountIcon from "../../../assets/vizr_images/Group-8.png";
import DTILogosmall from "../../../assets/icons/DTILogosmall.svg";
import HelpIcon from "../../../assets/vizr_images/Group-7.svg";
import LeftArrowIcon from "../../../assets/vizr_images/01. Inactive.svg";
import RightArrowIcon from "../../../assets/Images/inspect/ic_home.svg";
import DruvStarLogo from "../../../assets/vizr_images/02. Monotone Logo.svg";
import NewDruvstarLogo from "../../../assets/vizr_images/DDVWhiteLogo.svg";
import SmallDruvstarLogo from "../../../assets/vizr_images/logo.svg";
// import DropDownChevron from "../../../assets/vizr_images/ic_chevron_down.svg";
import MDRLogo from "../../../assets/vizr_images/ThreatInsightLogoWhite.svg";
import MDRLogoSmall from "../../../assets/vizr_images/MDRLogoSmall.svg";
import DashboardIcon from "../../../assets/vizr_images/Group-5.svg";
import userManagementIcon from "../../../assets/vizr_images/userManagement.svg";
import netspaceIcon from "../../../assets/icons/netspace.svg";
import settingsIcon from "../../../assets/vizr_images/SettingsIcon1.svg";
import { MDR, DDV, VIEW_COMPLIANCE, addTenantUser, RISK, NETSPACE, PROGRAM_OVERVIEW_FEATURE, PROGRAM_OVERVIEW_PERMISSION } from "../../../redux/constants/constants";
import farwardicon from "../../../assets/icons/farwardicon.svg";
import activeDashboard from "../../../assets/vizr_images/activeDashboard.svg";
import activeUserManagement from "../../../assets/vizr_images/activeUserManagement.svg";
import activeSettings from "../../../assets/vizr_images/activeSettings.svg";
import { activeRoutes } from "../../common/utilities";
import CanAllow from "../../shared/CanAllow";
import ManageRiskPilot from "../../views/RiskPilot/ManageRiskPilot";
import { RISK_PILOT } from "../../views/RiskPilot/riskPilotConstant";
import govfulllogo from "../../../assets/icons/govfulllogo.svg";
import QuickLinks from "../../common/Sidebar/QuickLinks";
import govfulllogosmall from "../../../assets/icons/govfulllogosmall.svg";

export default function Sidebar(props) {
  let history = useHistory();
  // const userEmail = localStorage.getItem("email");
  const isDruvstarUser = true; //userEmail && userEmail.endsWith("@druvstar.com");
  const {
    routes,
    bgColor,
    expand,
    handleShrink,
    isSignuppage,
    setProject,
    project,
  } = props;
  const permissions = useSelector((state) => state.applicationData.permissions);
  // const profilePicture = useSelector(
  //   (state) => state.signInpage.profilePicture
  // );
  const profilePicture = localStorage.getItem("profilePicture");
  const displayName = localStorage.getItem("displayName");
  const featuresData = JSON.parse(localStorage.getItem("featuresInfo"));
  const features =
    featuresData &&
    featuresData.features &&
    featuresData.features.map((data) => data.name);

  const [openHelpDialog, setOpenHelpDialog] = useState(false);
  var tenant = window.localStorage.getItem("tenant");
  const dispatch = useDispatch();
  let location = useLocation();

  const handleClickOpen = () => {
    setOpenHelpDialog(true);
  };
  const handleClose = () => {
    setOpenHelpDialog(false);
  };

  const userAccountClickHandler = () => {
    history.push("/gov/profileEditing");
  };

  return (
    <React.Fragment>
      {expand ? (
        <div
          className={"sidebar mdrlessheight Governorsidebar_bgimg"}
          style={{
            height: isSignuppage ? "1075px" : "1000px",
          }}
        >
          <div className="sidebar-wrapper increase-Pad">
            <Nav className="navbar" style={{ listStyleType: "none" }}>
              <div
                className="MDR-main-logo"
                onClick={() => {
                  history.push("/gov/GOVdashboards");
                }}
              >
                <img
                  src={govfulllogo}
                  alt={govfulllogo}
                  style={{ width: "100px", textAlign: "center" }}
                />
                {/* Data Vision */}
              </div>
              {isDruvstarUser && <CanAllow
                needs={{
                  permission: [PROGRAM_OVERVIEW_PERMISSION],
                  hasFeature: features && features.includes(PROGRAM_OVERVIEW_FEATURE)
                }}
              >
                <li className="MDR-list-items">
                  <Link
                    onClick={() =>
                      dispatch({
                        type: "TRACK_TRAVERSAL",
                        payload: `Dashboard`,
                      })
                    }
                    className="nav-link"
                    to={"/gov/statusdashboard"}
                    href={"/gov/statusdashboards"}
                    activeClassName="active"
                  >
                    <img className={
                      location && location.pathname.indexOf("/gov/statusdashboard") > -1
                        ? ""
                        : "dashboard-style"
                    }
                      src={activeRoutes(location, "/gov/statusdashboard", DashboardIcon, activeDashboard)}
                      alt={"Dashboard"} />
                    <p
                      className={
                        location && location.pathname.indexOf("/gov/statusdashboard") > -1
                          ? "active side-bar-para mdr-para"
                          : "side-bar-para mdr-para"
                      }
                    >
                      {"Program Overview"}
                    </p>
                  </Link>
                </li>
              </CanAllow>}
              <li className="MDR-list-items">
                <Link
                  onClick={() =>
                    dispatch({
                      type: "TRACK_TRAVERSAL",
                      payload: `Dashboard`,
                    })
                  }
                  className="nav-link"
                  to={"/gov/GOVdashboards"}
                  href={"/gov/GOVdashboards"}
                  activeClassName="active"
                >
                  <img className={
                    location && location.pathname.indexOf("/gov/GOVdashboards") > -1
                      ? ""
                      : "dashboard-style"
                  }
                    src={activeRoutes(location, "/gov/GOVdashboards", DashboardIcon, activeDashboard)}
                    alt={"Dashboard"} />
                  <p
                    className={
                      location && location.pathname.indexOf("/gov/GOVdashboards") > -1
                        ? "active side-bar-para mdr-para"
                        : "side-bar-para mdr-para"
                    }
                  >
                    {"Risk Dashboard"}
                  </p>
                </Link>
              </li>
              <CanAllow
                needs={{
                  permission: [RISK_PILOT],
                  hasFeature: features && features.includes(RISK)
                }}
              >
                <li className="MDR-list-items">
                  <ManageRiskPilot location={location} />
                </li>
              </CanAllow>
              <CanAllow needs={{ permission: [VIEW_COMPLIANCE] }}>
                <li className="MDR-list-items">
                  <Link
                    className="nav-link"
                    to={"/gov/compliancedashboard"}
                    href={"/gov/compliancedashboard"}
                    activeClassName="active"
                  >
                    <img
                      src={activeRoutes(location, "/gov/compliancedashboard", settingsIcon, activeSettings)}
                      alt={"settingsIcon"}
                    />
                    <p
                      className={
                        location && location.pathname.indexOf("/gov/compliancedashboard") > -1
                          ? "active side-bar-para mdr-para"
                          : "side-bar-para mdr-para"
                      }
                    >
                      {"Compliance"}
                    </p>
                  </Link>
                </li>
              </CanAllow>
              <QuickLinks currentPage={RISK} />
              <CanAllow needs={{ permission: [addTenantUser] }}>
                <li className="MDR-list-items gov-user-management">
                  <Link
                    onClick={() =>
                      dispatch({
                        type: "TRACK_TRAVERSAL",
                        payload: `User Management`,
                      })
                    }
                    className="nav-link"
                    to={"/gov/userManagement"}
                    href={"/gov/userManagement"}
                    activeClassName="active"
                  >
                    <img
                      src={activeRoutes(location, "/gov/userManagement", userManagementIcon, activeUserManagement)}
                      alt={"UserManagement"}
                    />
                    <p
                      className={
                        location && location.pathname.indexOf("/gov/userManagement") >
                          -1
                          ? "active side-bar-para mdr-para user-title"
                          : "side-bar-para mdr-para user-title"
                      }
                    >
                      {"User Management"}
                    </p>
                  </Link>
                </li>
              </CanAllow>
              {!isSignuppage && (
                <li className="user-account">
                  <ReactstrapNavLink onClick={userAccountClickHandler}>
                    {profilePicture ? (
                      <img
                        src={`data:image/png;base64,` + profilePicture}
                        alt={UserAccountIcon}
                      />
                    ) : (
                      <div className="userName">
                        {displayName &&
                          displayName.split(" ").map((el) => {
                            return el[0];
                          })}
                      </div>
                    )}

                    <p className="side-bar-para user-title">User Account</p>
                  </ReactstrapNavLink>
                </li>
              )}

              <li
                className={!isSignuppage ? "active-pro" : null}
              >
                <ReactstrapNavLink
                  style={{ cursor: "pointer" }}
                  onClick={() => handleClickOpen()}
                >
                  <img className="sidebar-small-icon" src={HelpIcon} alt={HelpIcon} />
                  <p className="side-bar-para user-title">Help & Support</p>
                </ReactstrapNavLink>
              </li>
              <li className="forward" onClick={handleShrink}>
                <IconButton>
                  <img src={LeftArrowIcon} alt={LeftArrowIcon} />
                </IconButton>
              </li>
            </Nav>
          </div>
        </div>
      ) : (
        <div className={"shrunk-sidebar Governor_bgimg_shrunk"}>
          <div className="sidebar-wrapper">
            <Nav className="navbar shrunk" style={{ listStyleType: "none" }}>
              <li className="shrunk-druvstar-logo">
                <ReactstrapNavLink
                  href="#"
                  className="MDR-shrunk-sidebar-icons"
                >
                  <img
                    src={govfulllogosmall}
                    alt={govfulllogosmall}
                    className="MDR-shrunk-sidebar-logo"
                    onClick={() => {
                      history.push("/gov/GOVdashboards");
                      dispatch({
                        type: "TRACK_TRAVERSAL",
                        payload: "Dashboard",
                      });
                    }}
                  />
                </ReactstrapNavLink>
              </li>
              <li className="shrunk-druvstar-logo">
                <ReactstrapNavLink
                  href="#"
                  className="MDR-shrunk-sidebar-icons"
                >
                  <img
                    src={activeRoutes(location, "/gov/GOVdashboards", DashboardIcon, activeDashboard)}
                    alt={"dasboardLogo"}
                    onClick={() => {
                      history.push("/gov/GOVdashboards");
                      dispatch({
                        type: "TRACK_TRAVERSAL",
                        payload: "Dashboard",
                      });
                    }}
                  />
                </ReactstrapNavLink>
              </li>
              <QuickLinks currentPage={RISK} shrunk={true} />
              <li className="shrink-user-account gov-user-management">
                <ReactstrapNavLink
                  href="#"
                  className="MDR-shrunk-sidebar-icons"
                >
                  <img
                    src={activeRoutes(location, "/gov/userManagement", userManagementIcon, activeUserManagement)}
                    alt={"user-management"}
                    onClick={() => {
                      history.push("/gov/userManagement");
                      dispatch({
                        type: "TRACK_TRAVERSAL",
                        payload: "User Management",
                      });
                    }}
                  />
                </ReactstrapNavLink>
              </li>
              {!isSignuppage ? (
                <li className="shrink-user-account">
                  <ReactstrapNavLink onClick={userAccountClickHandler}>
                    {profilePicture ? (
                      <img
                        src={`data:image/png;base64,` + profilePicture}
                        alt={UserAccountIcon}
                      />
                    ) : (
                      <div className="userName">
                        {displayName.split(" ").map((el) => {
                          return el[0];
                        })}
                      </div>
                    )}
                  </ReactstrapNavLink>
                </li>
              ) : null}

              <li className={!isSignuppage ? "active-pro" : null}>
                <ReactstrapNavLink href="#">
                  <img onClick={() => handleClickOpen()} className="sidebar-small-icon" src={HelpIcon} alt={HelpIcon} />
                </ReactstrapNavLink>
              </li>
              <li className="forward mdr-forward" onClick={handleShrink}>
                <IconButton>
                  <img src={RightArrowIcon} alt={"rightarrowicon"} />
                </IconButton>
              </li>
            </Nav>
          </div>
        </div>
      )}
      <>
        <Dialog
          open={openHelpDialog}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Druvstar Support"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please contact{" "}
              <i
                style={{
                  color: "#081981",
                  fontSize: "15px",
                  fontWeight: "500",
                }}
              >
                ddv.support@druvstar.com
              </i>
              , for further queries and support.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <NewPolicyButtonForPolicyCreateEdit
              style={{
                marginBottom: "0px",
                cursor: "pointer",
                width: "124px",
                height: "32px",
              }}
              onClick={() => handleClose()}
            //autoFocus
            >
              Close
            </NewPolicyButtonForPolicyCreateEdit>
          </DialogActions>
        </Dialog>
      </>
    </React.Fragment>
  );
}
